// @generated by protoc-gen-es v1.7.2
// @generated from file tendermint/types/block.proto (package tendermint.types, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Commit, Data, Header } from "./types_pb.js";
import { EvidenceList } from "./evidence_pb.js";

/**
 * @generated from message tendermint.types.Block
 */
export const Block = proto3.makeMessageType(
  "tendermint.types.Block",
  () => [
    { no: 1, name: "header", kind: "message", T: Header },
    { no: 2, name: "data", kind: "message", T: Data },
    { no: 3, name: "evidence", kind: "message", T: EvidenceList },
    { no: 4, name: "last_commit", kind: "message", T: Commit },
  ],
);

